import SMTWeekLog, {
  SMTWeekLogContent,
} from "@/ui/components/smt/SMTWeekLogSection/SMTWeekLog";
import SMTWeekLogSection, {
  SMTWeekLogSectionContent,
} from "@/ui/components/smt/SMTWeekLogSection/SMTWeekLogSection";

export default SMTWeekLogSection;
export { SMTWeekLog, SMTWeekLogContent, SMTWeekLogSectionContent };
export type { SMTWeekLogProps } from "@/ui/components/smt/SMTWeekLogSection/SMTWeekLog";
